export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_START';
export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_SUCCESS';
export const INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE =
  'INSTITUTION_ADMIN_UI_FETCH_ACTIVE_USERS_FAILURE';

export const INSTITUTION_COURSES_FETCH_START =
  'INSTITUTION_COURSES_FETCH_START';
export const INSTITUTION_COURSES_FETCH_FAILURE =
  'INSTITUTION_COURSES_FETCH_FAILURE';
export const INSTITUTION_COURSES_FETCH_SUCCESS =
  'INSTITUTION_COURSES_FETCH_SUCCESS';

export const FETCH_INSTITUTION_LINKABLE_COURSES_START =
  'FETCH_INSTITUTION_LINKABLE_COURSES_START';
export const FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS =
  'FETCH_INSTITUTION_LINKABLE_COURSES_SUCCESS';
export const FETCH_INSTITUTION_LINKABLE_COURSES_FAILURE =
  'FETCH_INSTITUTION_LINKABLE_COURSES_FAILURE';

export const LINK_COURSES_TO_INSTITUTION_SUCCESS =
  'LINK_COURSES_TO_INSTITUTION_SUCCESS';
export const LINK_COURSES_TO_INSTITUTION_FAILURE =
  'LINK_COURSES_TO_INSTITUTION_FAILURE';
export const TOGGLE_COURSE_CHECKBOX = 'TOGGLE_COURSE_CHECKBOX';

export const FETCH_INSTITUTION_LTI_CONSUMER_COURSES_SUCCESS =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSES_SUCCESS';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_START';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS';
export const FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE =
  'FETCH_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE';
export const UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS =
  'UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_SUCCESS';
export const UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE =
  'UPDATE_INSTITUTION_LTI_CONSUMER_COURSE_COHORTS_CONTEXT_IDS_FAILURE';
export const SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID =
  'SET_INSTITUTION_LTI_CONSUMER_COHORT_CONTEXT_ID';
export const FETCH_COURSE_CATEGORY_NAMES = 'FETCH_COURSE_CATEGORY_NAMES';

export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_START =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_START';
export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_FAILURE';
export const INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS =
  'INSTITUTION_ADMIN_UI_REMOVE_COURSE_SUCCESS';

export const INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION =
  'INSTITUTION_ADMIN_UI_COURSES_RESET_ACTION';

export const INSTITUTION_COURSES_AND_COHORTS_FETCH_START =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_START';
export const INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_SUCCESS';
export const INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE =
  'INSTITUTION_COURSES_AND_COHORTS_FETCH_FAILURE';

export const TOGGLE_COHORT_CHECKBOX = 'TOGGLE_COHORT_CHECKBOX';

export const INSTITUTION_SEND_INVITATION_START =
  'INSTITUTION_SEND_INVITATION_START';
export const INSTITUTION_SEND_INVITATION_SUCCESS =
  'INSTITUTION_SEND_INVITATION_SUCCESS';
export const INSTITUTION_SEND_INVITATION_FAILURE =
  'INSTITUTION_SEND_INVITATION_FAILURE';
export const INSTITUTION_SEND_INVITATION_FINISH =
  'INSTITUTION_SEND_INVITATION_FINISH';

export const INSTITUTION_INVITE_COURSE_SELECTED =
  'INSTITUTION_INVITE_COURSE_SELECTED';
export const FETCH_INSTITUTION_INVITE_COURSE_SUCCESS =
  'FETCH_INSTITUTION_INVITE_COURSE_SUCCESS';
export const FETCH_INSTITUTION_INVITE_COURSE_FAILURE =
  'FETCH_INSTITUTION_INVITE_COURSE_FAILURE';

export const REMOVE_FROM_SELECTED_COURSES = 'REMOVE_FROM_SELECTED_COURSES';

export const FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_START =
  'FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_START';
export const FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_SUCCESS =
  'FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_SUCCESS';
export const FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_FAILURE =
  'FETCH_INSTITUTION_HAS_REACHED_LEARNER_LIMIT_FAILURE';

export const FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_START =
  'FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_START';
export const FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_SUCCESS =
  'FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_SUCCESS';
export const FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_FAILURE =
  'FETCH_SHOW_INSTITUTION_SETTINGS_POPUP_FAILURE';

export const HIDE_INSTITUTION_SETTINGS_POPUP_START =
  'HIDE_INSTITUTION_SETTINGS_POPUP_START';
export const HIDE_INSTITUTION_SETTINGS_POPUP_SUCCESS =
  'HIDE_INSTITUTION_SETTINGS_POPUP_SUCCESS';
export const HIDE_INSTITUTION_SETTINGS_POPUP_FAILURE =
  'HIDE_INSTITUTION_SETTINGS_POPUP_FAILURE';

export const FETCH_INSTITUTION_USAGE_FAILURE =
  'FETCH_INSTITUTION_USAGE_FAILURE';
export const FETCH_INSTITUTION_USAGE_START = 'FETCH_INSTITUTION_USAGE_START';
export const FETCH_INSTITUTION_USAGE_SUCCESS =
  'FETCH_INSTITUTION_USAGE_SUCCESS';

export const FETCH_SUBSCRIPTION_INFO_FAILURE =
  'FETCH_SUBSCRIPTION_INFO_FAILURE';
export const FETCH_SUBSCRIPTION_INFO_START = 'FETCH_SUBSCRIPTION_INFO_START';
export const FETCH_SUBSCRIPTION_INFO_SUCCESS =
  'FETCH_SUBSCRIPTION_INFO_SUCCESS';

export const SET_ACTIVE_USERS_DATE_RANGE = 'SET_ACTIVE_USERS_DATE_RANGE';

export const FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_START =
  'FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_START';
export const FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_SUCCESS =
  'FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_SUCCESS';
export const FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_FAILURE =
  'FETCH_ACCREDIBLE_TEAM_MEMBER_INFO_FAILURE';

export const UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_START =
  'UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_START';
export const UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_SUCCESS =
  'UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_SUCCESS';
export const UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_EMAIL_ERROR =
  'UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_EMAIL_ERROR';
export const UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_FAILURE =
  'UPDATE_ACCREDIBLE_TEAMMEMBER_PERMISSION_FAILURE';
export const GET_COURSES_USER_ADMINISTERS_LOADING =
  'GET_COURSES_USER_ADMINISTERS_LOADING';
export const GET_COURSES_USER_ADMINISTERS_FAILED =
  'GET_COURSES_USER_ADMINISTERS_FAILED';
export const GET_COURSES_USER_ADMINISTERS = 'GET_COURSES_USER_ADMINISTERS';

export const FETCH_INSTITUTION_LEARNER_USAGE_START =
  'FETCH_INSTITUTION_LEARNER_USAGE_START';
export const FETCH_INSTITUTION_LEARNER_USAGE_COMPLETE =
  'FETCH_INSTITUTION_LEARNER_USAGE_COMPLETE';

export const FETCH_AUTO_MEMBERSHIP_ENABLED_START =
  'FETCH_AUTO_MEMBERSHIP_ENABLED_START';
export const FETCH_LTI_CONSUMER_SETTINGS_SUCCEED =
  'FETCH_LTI_CONSUMER_SETTINGS_SUCCEED';
export const FETCH_LTI_CONSUMER_SETTINGS_FAILED =
  'FETCH_LTI_CONSUMER_SETTINGS_FAILED';

export const SET_AUTO_MEMBERSHIP_ENABLED_START =
  'SET_AUTO_MEMBERSHIP_ENABLED_START';
export const SET_AUTO_MEMBERSHIP_ENABLED_SUCCEED =
  'SET_AUTO_MEMBERSHIP_ENABLED_SUCCEED';
export const SET_AUTO_MEMBERSHIP_ENABLED_FAILED =
  'SET_AUTO_MEMBERSHIP_ENABLED_FAILED';

export const SET_IDP_CONFIG_SUCCEED = 'SET_IDP_CONFIG_SUCCEED';
export const SET_LTI_ROLES_MAPPING = 'SET_LTI_ROLES_MAPPING';
export const SET_IDP_CONFIG_FAILED = 'SET_IDP_CONFIG_FAILED';
export const FETCH_IDP_CONFIG_DATA_SUCCEED = 'FETCH_IDP_CONFIG_DATA_SUCCEED';
export const REMOVE_IDP_CONFIG_SUCCEED = 'REMOVE_IDP_CONFIG_SUCCEED';
